// extracted by mini-css-extract-plugin
module.exports = {"formControlIconWrap":"PasswordType_formControlIconWrap__IpxIB"};